import { useMutation, useQuery } from "@tanstack/react-query";
import api from './memberTypewiseSectionConfig.requests'
import { number } from "zod";
import { IMemberTypewiseSectionConfigGridPostModel } from "./memberTypewiseSectionConfig.types";

const QUERY_KEY = "memberTypewiseSectionConfig";

function getQueryKey(id?: string | number) {
    if (id === undefined) {
        return [QUERY_KEY];
    }
    return [QUERY_KEY, id];
}

export function getMemberTypewiseSectionConfig(id: string | number | undefined) {
    const query = useQuery({
        queryKey: [getQueryKey(id)],
        queryFn: () => api.getById(id || ""),
        enabled: Boolean(id)
    })
    return query
}

export function getMemberTypewiseSectionConfigs(model: IMemberTypewiseSectionConfigGridPostModel){
     const query = useQuery({
        queryKey:[QUERY_KEY],
        queryFn:()=>api.getAll(model),
     })
     return query
}

export function updateMemberTypewiseSectionConfig() {
    const mutation = useMutation({
      mutationFn: api.update,
    });
  
    return mutation;
  }
  
  export function createMemberTypewiseSectionConfig() {
    const mutation = useMutation({
      mutationFn: api.create
    });
  
    return mutation;
  }

  export function deleteMemberTypewiseSectionConfig() {
    const mutation = useMutation({
      mutationFn: api.delete,
    });
  
    return mutation;
  } 